
import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface AmountInputProps {
  amount: string;
  unit: string;
  onAmountChange: (value: string) => void;
  onUnitChange: (value: string) => void;
}

const AmountInput = ({ amount, unit, onAmountChange, onUnitChange }: AmountInputProps) => {
  // Units for dropdown
  const units = ["g", "mg", "µg", "kg", "L", "mL", "µL"];

  return (
    <div className="space-y-2">
      <Label htmlFor="amount">Amount</Label>
      <div className="flex gap-2">
        <Input
          id="amount"
          name="amount"
          value={amount}
          onChange={(e) => onAmountChange(e.target.value)}
          placeholder="e.g., 100"
          className="flex-grow"
        />
        <Select
          value={unit}
          onValueChange={onUnitChange}
        >
          <SelectTrigger id="unit" className="w-24">
            <SelectValue placeholder="Unit" />
          </SelectTrigger>
          <SelectContent>
            {units.map((u) => (
              <SelectItem key={u} value={u}>
                {u}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default AmountInput;
